import { render, staticRenderFns } from "./myAddrMsg.vue?vue&type=template&id=a12449e0&scoped=true"
import script from "./myAddrMsg.vue?vue&type=script&lang=js"
export * from "./myAddrMsg.vue?vue&type=script&lang=js"
import style0 from "./myAddrMsg.vue?vue&type=style&index=0&id=a12449e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12449e0",
  null
  
)

export default component.exports